import FilterDrawer from './src/filter-drawer.vue';

FilterDrawer.install = function (Vue) {
  Vue.component(FilterDrawer.name, FilterDrawer);
};

export default FilterDrawer;
